import React, { useEffect } from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsOfService: React.FC = () => {
  useEffect(() => {
    document.title = 'Terms of Service — Buy Drop';
  }, []);

  return (
    <LegalPageLayout title="Terms of Service">
      <p className="text-sm leading-relaxed mb-6">
        These Terms of Service (&quot;Terms&quot;) govern your use of Buy Drop&apos;s websites, apps, and related
        services (collectively, the &quot;Services&quot;). By accessing or using the Services, you agree to these
        Terms. If you do not agree, do not use the Services.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">1. The Services</h2>
      <p className="text-sm leading-relaxed mb-4">
        Buy Drop provides an online marketplace that connects buyers and sellers. We may update, suspend, or
        discontinue features at any time. Seller tools may be offered through companion mobile applications; website
        features may vary by platform.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">2. Accounts</h2>
      <p className="text-sm leading-relaxed mb-4">
        You must provide accurate information and keep your account secure. You are responsible for activity under
        your account. We may refuse service, close accounts, or remove content that violates these Terms or applicable
        law.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">3. Marketplace conduct</h2>
      <ul className="list-disc pl-5 text-sm leading-relaxed space-y-2 mb-4">
        <li>Listings and communications must be lawful, honest, and not misleading.</li>
        <li>You may not use the Services to harass others, distribute malware, or circumvent fees or policies.</li>
        <li>Transactions between users are primarily between buyer and seller; Buy Drop may facilitate payments or
          logistics as described at checkout or in separate seller agreements.</li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">4. Fees and payments</h2>
      <p className="text-sm leading-relaxed mb-4">
        Fees, taxes, and payout timing may apply as disclosed in the product or at checkout. Third-party payment
        processors have their own terms.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">5. Intellectual property</h2>
      <p className="text-sm leading-relaxed mb-4">
        Buy Drop and its licensors own the Services and branding. You retain rights in content you submit; you grant Buy
        Drop a license to host, display, and operate the Services using that content.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">6. Disclaimers</h2>
      <p className="text-sm leading-relaxed mb-4">
        The Services are provided &quot;as is.&quot; To the fullest extent permitted by law, Buy Drop disclaims
        warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee
        uninterrupted or error-free operation.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">7. Limitation of liability</h2>
      <p className="text-sm leading-relaxed mb-4">
        To the fullest extent permitted by law, Buy Drop will not be liable for indirect, incidental, special,
        consequential, or punitive damages, or loss of profits or data, arising from your use of the Services.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">8. Changes</h2>
      <p className="text-sm leading-relaxed mb-4">
        We may modify these Terms by posting an updated version on this page. Continued use after changes constitutes
        acceptance of the revised Terms where permitted by law.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">9. Contact</h2>
      <p className="text-sm leading-relaxed">
        Questions about these Terms:{' '}
        <a href="mailto:support@buydrop.com" className="text-green-700 font-medium hover:underline">
          support@buydrop.com
        </a>
        .
      </p>
    </LegalPageLayout>
  );
};

export default TermsOfService;
